

























import Vue from 'vue'
import { IAttachment } from '@/types/data-objects/attachments'
import { IDynamicObject } from '@/types'

import GoogleDriveIcon from '@/components/item/attachments-list/img/attachment-google-drive.svg'
import PdfIcon from '@/components/item/attachments-list/img/attachment-pdf.svg'
import ExcelIcon from '@/components/item/attachments-list/img/attachment-excel.svg'
import ImageIcon from '@/components/item/attachments-list/img/attachment-image.svg'
import WordIcon from '@/components/item/attachments-list/img/attachment-word.svg'
import ZipIcon from '@/components/item/attachments-list/img/attachment-zip.svg'
import AttachmentIcon from '@/components/item/attachments-list/img/attachment.svg'

export default Vue.extend({
  name: 'AttachmentsDropdown',
  props: {
    listAttachments: {
      type: Array as () => IAttachment[],
      default: (): IAttachment[] => [],
    },
  },

  computed: {
    hasAttachments(): Boolean {
      return this.listAttachments.length > 0
    },
    fileTypesIcons(): IDynamicObject {
      return {
        googleDrive: GoogleDriveIcon,
        file_pdf: PdfIcon,
        file_img: ImageIcon,
        file_doc: WordIcon,
        file_xls: ExcelIcon,
        file_zip: ZipIcon,
        file: AttachmentIcon,
      }
    },
    listAttachmentsIcon(): any {
      return this.listAttachments.map(item => {
        return {
          ...item,
          icon: this.getFileTypeIcon(item.type),
        }
      })
    },
  },

  methods: {
    getFileTypeIcon(type: string): string {
      return this.fileTypesIcons[type]
    },
  },
})
